import React, {useEffect, useState, useRef} from 'react'
import { buyers } from '../Options'
import Select from 'react-select'
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'

export default function LintCottonForm() {
  //states
  const [date, setDate] = useState('2023-08-09')
  const [province_id, setProvinceID] = useState('')
  const [province, setProvince] = useState('')
  const [district_id, setDistrictID] = useState('')
  const [district, setDistrict] = useState('')
  const [station_id, setStationID]= useState('')
  const [station, setStation] = useState('')
  const [seller, setSeller] = useState()
  const [buyer, setBuyer] = useState()
  const [qualityType, setQualityType]= useState()
  const [dealType, setDealType] = useState()
  const [rates, setRates]= useState()
  const [clbs, setClbs]  = useState()
  const [bales, setBales] = useState()
  const [dollarRate, setDollarRate] = useState()
  const [x, setX] = useState()
  const [rateAvl, setRateAvl] = useState(false)
  //for getting to the item quicker
  const [searchTerm, setSearchTerm] = useState('');
  const [options2, setOptions2] = useState([])
  const [buyers2, setBuyers2]= useState([])
  const [selectedOptions, setSelectedOptions] = useState('')
  const [selectedOptions2, setSelectedOptions2] = useState('')
  //Message
  const [sSubmit, setSSubmit] = useState('')
  const [pSubmit, setPSubmit] = useState('')
  const [bSubmit, setBSubmit] = useState('')

  //Stations
  const [options, setOptions] =useState([])

  //references
  const statRef = useRef(null)
  const sellRef = useRef(null)
  const buyRef = useRef(null)
  const qualRef = useRef(null)
  const dealRef = useRef(null)
  const rateRef = useRef(null)
  const clbsRef = useRef(null)
  const baleRef = useRef(null)

  //reset on submit
  const reset =()=>{
    statRef.current.value=''
    sellRef.current.value=''
    buyRef.current.value=''
    qualRef.current.value=''
    dealRef.current.value=''
    rateRef.current.value=''
    clbsRef.current.value=''
    baleRef.current.value=''
    setStation(null)
    setSeller(null)
    setBuyer(null)
    setQualityType(null)
    setDealType(null)
    setBales(null)
    setRates(null)
    setClbs(null)
    setSelectedOptions(null)
    setSelectedOptions2(null)
  }

  // Set the default value to today's date in "YYYY-MM-DD" format
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setDate(today);
  }, []);

  useEffect(()=>{
    const crickets = options
    const searchTerm = crickets.map((cricket) => ({
      value: cricket.name,
      label: cricket.name
    }));
    setOptions2(searchTerm)
    const stumps = buyers
    const searcher = stumps.map((stump)=>({
      value:stump.name,
      label:stump.name
    }))
    setBuyers2(searcher)
  }, [options])
  
  const ferrit = async() =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getLookup`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()
    setOptions(data)
  }
  useEffect(()=>{
    ferrit()
  },[])

  //date change handle
  const dateHandler = (e) =>{
    setDate(e.target.value)
  }
  useEffect(()=>{
    dateRate(date)
  }, [date])

  //station handler
  //function to set province, district station just through stations code
  const stationHandler = (item) => {
    const selectedName = item;
    const selected = options.find(option => option.name === selectedName);

    setStation(selectedName)
    setStationID(String(selected.value));
    setProvince(selected.province);
    setProvinceID(String(selected.province_id));
    setDistrict(selected.district)
    setDistrictID(String(selected.district_id));
  };

  //seller handler
  const sellerHandler = (e) =>{
    setSeller(e.target.value)
  }



  //buyer handler
  const buyerHandler = (item) =>{
    setBuyer(item)
  }



  //quality type handler
  const qualityTypeHandler =(e)=>{
    const selectedText = e.target.options[e.target.selectedIndex].text;
    setQualityType(selectedText)
  }



  //deal type
  const dealTypeHandler = (e)=>{
    const selectedText = e.target.options[e.target.selectedIndex].text;
    setDealType(selectedText)
  }



  //rates
  const ratesHandler =(e)=>{
    const inputValue = e.target.value
    const numericValue = parseFloat(inputValue)
    setRates(numericValue)
    const clbsValue = (numericValue / x).toFixed(2);
    setClbs(clbsValue);
  }



  //clbs
  const clbsHandler =(e) =>{
    setClbs(e.target.value)
  }



  //bales
  const balesHandler = (e)=>{
    setBales(e.target.value)
  }



  //values for the last submit
  const setLast = (station, seller, buyer) =>{
    setSSubmit(station)
    setBSubmit(buyer)
    setPSubmit(seller)
  } 


  //fetching the USD rate
  const gerrit =async ()=>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/usd-rate-ch`,{
      headers: {
        'x-access-token': token
      }
    })
    if(!response.ok){
      setRateAvl(false)
    }
    else{
      const data = await response.json()
      setDollarRate(data.buying)
      setRateAvl(true)
    }
  }

  useEffect(()=>{
    gerrit()
  }, [])

  useEffect(()=>{
    setX((dollarRate*82.28456)/100)
  }, [dollarRate])



  const dateRate = async (date) =>{
    const token = sessionStorage.getItem('token')
    const url = `${process.env.REACT_APP_API_URL}/usd-rate-ch?dates=${date}`
    const response = await fetch(url, {
      method:"GET",
      headers:{
        "Content-Type":"application/json",
        'x-access-token':token
      }
    })
    if(!response.ok){
      setRateAvl(false)
    }
    else{
      const data = await response.json()
      setDollarRate(data.buying)
      setRateAvl(true)
    }
  }

  
  const handleSubmit = async(e) =>{
    e.preventDefault()
    if(!rateAvl){
      alert("There is no usd value therefore cannot submit!")
    }
    else{
      if(date === null || station === null || seller === null || buyer === null || qualityType === null || dealType== null || rates === null || bales === null || clbs === null){
        return// console.log("No field is supposed to be empty")
      }
      const lint = {
        date: new Date(date) , 
        product_id:"1", 
        product:"Cotton", 
        by_product_id:"14", 
        by_product:"lint_cotton",  
        station_id, 
        station, 
        district_id,  
        province_id: Number(province_id), 
        province, 
        seller, 
        buyer, 
        quality_type: qualityType, 
        deal_type: dealType, 
        minimum:rates, 
        maximum:rates, 
        bales: Number(bales)
      }
      lint['c/lbs'] = Number(clbs)

      const token = sessionStorage.getItem('token')
      await fetch(`${process.env.REACT_APP_API_URL}/admin/prices`,{
        method: "POST",
        headers: {
          "Content-Type":"application/json",
          'x-access-token':token
        },
        body: JSON.stringify([lint])
      })
        // .then(console.log("Submitted successfully!")).then(setLast(lint.station, lint.seller, lint.buyer)).then(reset())
    }
    }


  return (
    <>
        <div className="sidebar">
    <Sidebar/>
    </div>
    <div id="tabler">
    <h1>Lint Cotton Price</h1>
      <form onSubmit={handleSubmit} className='needs-validation'>
          <div className="row">
              <div className="col-md-6">
                  {/**Date */}
                  <label htmlFor="num-value" className="form-label">Date</label>
                  <div className="input-group input-group-md mb-3">
                      <input type="date" id="num-value" className="form-control" aria-label="Small" required value={date || ""} onChange={dateHandler} aria-describedby="inputGroup-sizing-sm" />
                  </div>
              </div>
                  {/**Station */}
              <div className="col-md-6">
                  <label htmlFor="inputGroupSelect07" className="form-label">Station</label>
                  <Select options={options2} required ref={statRef} value={selectedOptions}  placeholder="station"  onChange={(stat)=>{
                    const {value, label} = {...stat}
                    setSelectedOptions(stat)
                    stationHandler(value)
                  }} isSearchable noOptionsMessage={()=> "Not found"}/>
              </div>

              
          </div>
      
          <div className="row">
              <div className="col-md-6">
                  {/**Seller */}
                  <label htmlFor="sellerInput" className="form-label">Seller</label>
                  <div className="input-group input-group-md mb-3">
                      <input type="text" id="sellerInput" className="form-control" aria-label="Small" onChange={sellerHandler} ref={sellRef} required aria-describedby="inputGroup-sizing-sm" />
                  </div>
              </div>

              <div className="col-md-6">
                  {/**Buyer */}
                  <label htmlFor="inputGroupSelectBuyer" className="form-label">Buyer</label>
                    <Select options={buyers2} required ref={buyRef} value={selectedOptions2}  placeholder="buyer"  onChange={(stat)=>{
                                        const {value, label} = {...stat}
                                        setSelectedOptions2(stat)
                                        buyerHandler(value)
                                      }} isSearchable noOptionsMessage={()=> "Not found"}/>
              </div>
          </div>
      
          <div className="row">
              <div className="col-md-6">
                  {/**Quality Type*/}
                  <label for="exampleFormControlTextarea1" class="form-label">Quality Type</label>
            <div className="input-group mb-3">
              <select className="form-select" id="inputGroupSelect07" onChange={qualityTypeHandler}required ref={qualRef} aria-label="Select example">
                <option value="">Select quality type</option>
                <option value="1">Normal</option>
                <option value="2">Low</option>
                <option value="3">Good</option>
              </select>
            </div>
              </div>
              <div className="col-md-6">
                  {/**Deal Type */}
                  <label for="exampleFormControlTextarea1" class="form-label" >Deal Type</label>
            <div className="input-group mb-3" >
              <select className="form-select" id="inputGroupSelect07" onChange={dealTypeHandler}required ref={dealRef} aria-label="Select example">
                <option value="">Select deal type</option>
                <option value="1">Normal</option>
                <option value="2">Conditional</option>
              </select>
            </div>
              </div>
          </div>
      
          {rateAvl && <div className="row">
              <div className="col-md-6">
                  {/**Rates*/}
                  <label for="exampleFormControlTextarea1" class="form-label" >Rates</label>
              <div class="input-group input-group-md mb-3">
                  <input type="number" step="any"class="form-control" aria-label="Small"onChange={ratesHandler} ref={rateRef} min="0"required aria-describedby="inputGroup-sizing-sm"/>
              </div>
              </div>
              
              <div className="col-md-6">
                  {/**Clbs */}
                  <label for="exampleFormControlTextarea1" class="form-label" >C/lbs</label>
              <div class="input-group input-group-md mb-3">
                  <input type="number" class="form-control" aria-label="Small" step="0.000000000000000001" value={clbs} onChange={clbsHandler}ref={clbsRef}min="0" required aria-describedby="inputGroup-sizing-sm" disabled/>
              </div>
              </div>
          </div>}

          {!rateAvl && 
          <div class="alert alert-danger d-flex align-items-center" role="alert">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
</svg> <div>        
                      No USD rate found for the given date. Make sure rate is uploaded to be able to submit the form
          </div>
          </div>
          }

          
          {!rateAvl && 
          <div className="row">
              <div className="col-md-6">
                  {/**Rates*/}
                  <label for="exampleFormControlTextarea1" class="form-label" >Rates</label>
              <div class="input-group input-group-md mb-3">
                  <input disabled type="number" step="any"class="form-control" aria-label="Small" min="0"required aria-describedby="inputGroup-sizing-sm"/>
              </div>
              </div>
              <div className="col-md-6">
                  {/**Clbs */}
                  <label for="exampleFormControlTextarea1" class="form-label" >Clbs</label>
              <div class="input-group input-group-md mb-3">
                  <input disabled type="number" class="form-control" aria-label="Small" step="0.000000000000000001" min="0" required aria-describedby="inputGroup-sizing-sm"/>
              </div>
              </div>
          </div>}
      

          <div className="row">
              <div className="col-md-6">
                  {/**Rates*/}
                  <label for="exampleFormControlTextarea1" class="form-label" >Bales</label>
              <div class="input-group input-group-md mb-3">
                  <input type="number" class="form-control" aria-label="Small" onChange={balesHandler} ref={baleRef} min="0" required aria-describedby="inputGroup-sizing-sm"/>
              </div>
              </div>
          </div>
      
          <button type="submit"  className="btn submit-btn">Submit</button>
      </form>
      <div style={{border:"1px solid #ced4da",  borderRadius:"30px",marginTop:"20px", padding:"20px", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', backgroundColor:"#ced4da" }}>
        <div className="row" >
          <div className="col-md-4" style={{justifyItems:"center"}} ><h5 style={{color: "#6486eb "}}>SELLER</h5>
          <div> {pSubmit}</div>
          </div>
          <div className="col-md-4"><h5 style={{color: "#6486eb "}}>BUYER</h5> 
          <div>
          {bSubmit}
          </div>
         </div>
          <div className="col-md-4"><h5 style={{color: "#6486eb "}}>STATION</h5> 
              <div>{sSubmit}</div>
          </div>
        </div>
      </div>
          </div>
    </>
  )
}